import { Box, IconButton, styled, Typography } from '@mui/material';

export const MainContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: theme.palette.background.paper,
  ...(theme.palette.mode === 'dark'
    ? { boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.4)', border: `1px solid ${theme.palette.divider}` }
    : { boxShadow: '0px 21px 34px 0px #C1C1C129', border: 'none !important' }
  ),
  borderRadius: 24,
  padding: 32,
  gap: 24,
  maxWidth: 340,
}));

export const ContentWrapper = styled(Box)({
  display: 'flex',
  height: 40,
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const ContentStyledBox = styled(Box)({
  display: 'flex',
  gap: 24,
  flexDirection: 'column',
});

export const DescriptionWrapper = styled(Typography)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  color: theme.palette.text.tertiary,
  fontSize: 12,
  fontWeight: 500,
}));

export const ButtonWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '8px',
  alignItems: 'center',
  justifyContent:'center'
}));

export const CloseIconButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: 23,
  right: 22,
  zIndex: 1,
  opacity: 10,
}));
